import React from 'react';
import ReactCalendar from 'react-calendar';
import { format, isSameDay } from 'date-fns';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import useDatesForDateRange from '@hooks/useDatesForDateRange';

const Container = styled.div`
    border: 1px solid ${colors.lightGray};
    padding: 16px 10px;

    @media ${mediaQueries.md} {
        padding: 32px 40px;
    }
`;

const Calendar = ({ activeDate, allowedDateRange, children, onActiveDateChange }) => {
    const dateRange = useDatesForDateRange(allowedDateRange);

    return (
        <Container>
            <ReactCalendar
                calendarType="US"
                defaultActiveStartDate={dateRange.length > 0 ? dateRange[0].date : null}
                formatShortWeekday={(locale, date) => format(date, 'EEE')}
                tileClassName={({ date }) => {
                    if (isSameDay(date, activeDate)) {
                        return 'active';
                    }

                    if (dateRange.find(eventDay => isSameDay(date, eventDay.date))) {
                        return 'selectable';
                    }
                }}
                tileDisabled={({ date }) => !dateRange.find(eventDay => isSameDay(date, eventDay.date))}
                onClickDay={onActiveDateChange}
            />

            {children && <div className="mt-2rem">{children}</div>}
        </Container>
    );
};

Calendar.propTypes = {
    activeDate: PropTypes.instanceOf(Date).isRequired,
    allowedDateRange: PropTypes.shape({
        startDate: PropTypes.instanceOf(Date).isRequired,
        endDate: PropTypes.instanceOf(Date).isRequired,
    }),
    children: PropTypes.node,
    onActiveDateChange: PropTypes.func.isRequired,
};

export default Calendar;
